import { AnimatePresence, motion } from 'framer-motion'
import type { ActionPayload } from '../../types/ai'
import { Button } from '../Common/Button'
import { useNls } from '../../nls/nlsProvider'
import { getLineQuickActionApplyLabel } from '../AiMagicNls'

export const QuickActionsTray = ({
  actions,
  onApply,
  onReject,
  error,
  onRetry,
}: {
  actions: ActionPayload[]
  onApply: () => void
  onReject: () => void
  error?: string | null
  onRetry?: () => void
}) => {
  const { t } = useNls()
  return (
    <AnimatePresence initial={false}>
      {actions.length > 0 && (
        <motion.div
          className="lineQuickActionsTray"
          aria-label={t('NLSAiQuickActionsAria')}
          initial={{ opacity: 0, y: 6 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 4 }}
          transition={{ duration: 0.16, ease: 'easeOut' }}
        >
          {error && <span className="lineQuickActionsError" role="alert">{error}</span>}
          {error && onRetry ? (
            <Button size="sm" variant="primary" onClick={onRetry}>{t('NLSAiActionRetry')}</Button>
          ) : (
            <Button size="sm" variant="primary" onClick={onApply}>{getLineQuickActionApplyLabel(actions, t)}</Button>
          )}
          <Button size="sm" variant="tertiary" tone="danger" onClick={onReject}>{t('NLSAiActionReject')}</Button>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
